import { createContext } from 'react';

const useFieldEngagementContext = createContext();
export default useFieldEngagementContext;
